import React, { useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import { saveAs } from "file-saver";
import "./PayoutStatus.css";

const SeltousSuryoday = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileUpload = (event) => {
    setFile(event.target.files[0]);
  };

  const processFile = async () => {
    if (!file) return alert("Please upload an Excel file!");

    setLoading(true);
    const reader = new FileReader();

    reader.onload = async (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      if (jsonData.length === 0 || !jsonData[0].hasOwnProperty("merchantRefNo")) {
        setLoading(false);
        return alert('Invalid file! The "merchantRefNo" field is missing.');
      }

      
      const results = [];

      for (const row of jsonData) {
        const merchantRefNo = row["merchantRefNo"];
        if (!merchantRefNo) continue;

        try {
          const response = await axios.post(
            "https://admin.therareman.com/backend/suryoday/v1/payout/status/raw-response",
            { merchantRefNo: String(merchantRefNo) },
            { headers: { "Content-Type": "application/json" } }
          );

        //   console.log("API Response:", response.data);

          const { info } = response.data;
          results.push({
            orderId: merchantRefNo,
            amount: info.amount || "N/A",
            status: info.status || "N/A",
            rawStatus: JSON.stringify(response.data) || "N/A",
          });
        } catch (error) {
          console.error("API Error:", error.response?.data || error.message);

          results.push({
            orderId: merchantRefNo,
            amount: "N/A",
            status: "ERROR",
            rawStatus: error.response?.data?.message || error.message || "Failed",
          });
        }
      }

      setLoading(false);
      generateExcel(results);
    };

    reader.readAsBinaryString(file);
  };

  const generateExcel = (resultData) => {
    const ws = XLSX.utils.json_to_sheet(resultData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Payout Status");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "seltous_suryoday.xlsx");
  };

  return (
    <div className="container-payout">
      <h2 className="title-payout">Seltous Suryoday Raw Status</h2>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} className="input-payout" />
      <button onClick={processFile} disabled={loading} className={`buttonPayout ${loading ? "disabled" : ""}`}>
        {loading ? "Processing..." : "Check Status"}
      </button>
    </div>
  );
};

export default SeltousSuryoday;
